<template>
  <AppLayout>
    <div class="vp-flex vp-flex-col vp-justify-between">
      <div class="vp-flex vp-justify-center vp-h-full vp-overflow-auto">
        <TheFeatures class="vp-mt-14" />
      </div>
      <GetStartedCta>
        What’s holding you back? Create your catalog now!
        <template #action>
          <VpButtonPill
            :href="toStore('get-started')"
            class="vp-flex-row-reverse vp-gap-2"
            :icon="$options.icons.ArrowRight"
            label="Get Started"
          />
        </template>
      </GetStartedCta>
    </div>
  </AppLayout>
</template>

<script>
import TheFeatures from "./_features.vue";
import { ArrowRight } from "icons/icons.js";
import GetStartedCta from "components/src/get-started-cta.vue";
import AppLayout from "@/components/app-layout.vue";
import { toStore } from "plugins/utils.js";
export default {
  icons: {
    ArrowRight,
  },
  components: {
    AppLayout,
    GetStartedCta,
    TheFeatures,
  },
  methods: {
    toStore,
  },
};
</script>
